import styles from './ErrorMessage.module.css';

interface ErrorMessageProps {
  error?: string;
  visible?: boolean;
}

export function ErrorMessage({ error, visible }: ErrorMessageProps) {
  if (!visible || !error) return null;

  return <p className={styles.error}>{error}</p>;
}

export default ErrorMessage;
